import { IViewModel } from '../../interfaces/view-model.interface';

// Note:  this class is intended to contain all of the permissions needed by a forms grid,
//        BUT, for the time being, only the 'CanReorderForms' permissions is being implemented.
export class UserHomePagePermissions implements IViewModel {
    public id: number; // Note:  this is meaningless/unused value meant merely to conform with interface IViewModel.

    // Define permissions values (presently only one).
    public userCanReorderForms: boolean;
}
